import React from "react";
import { useGetVideoGalleryQuery } from "../products/productSlice";

import video1 from "../../assets/img/video/VID-20251110-WA0001.mp4";
import video2 from "../../assets/img/video/VID-20251110-WA0002.mp4";
import video3 from "../../assets/img/video/VID-20251110-WA0003.mp4";
import video4 from "../../assets/img/video/VID-20251110-WA0004.mp4";
import video5 from "../../assets/img/video/VID-20251110-WA0005.mp4";
import video6 from "../../assets/img/video/VID-20251110-WA0006.mp4";
import video7 from "../../assets/img/video/VID-20251110-WA0007.mp4";
import video8 from "../../assets/img/video/VID-20251110-WA0008.mp4";
import video9 from "../../assets/img/video/VID-20251110-WA0009.mp4";
import video10 from "../../assets/img/video/VID-20251110-WA0010.mp4";
import video11 from "../../assets/img/video/VID-20251110-WA0011.mp4";
import video12 from "../../assets/img/video/VID-20251110-WA0012.mp4";
import video13 from "../../assets/img/video/VID-20251110-WA0013.mp4";
import video14 from "../../assets/img/video/VID-20251110-WA0014.mp4";

const videoData = [
  { id: 1, url: video1 },
  { id: 13, url: video13 },
  { id: 14, url: video14 },
  { id: 3, url: video3 },
  { id: 2, url: video1 },
  // { id: 2, url: video2 },
  // { id: 4, url: video4 },
  { id: 5, url: video5 },
  { id: 6, url: video6 },
  // { id: 7, url: video7 },
  // { id: 8, url: video8 },
  // { id: 9, url: video9 },

  { id: 10, url: video10 },
  { id: 11, url: video11 },
];
function VideoGallery() {
  const { data, isLoading } = useGetVideoGalleryQuery();
  return (
    <>
      <section className="videoGallery sectionPD">
        <div className="container">
          <div className="row">
            {isLoading && (
              <div className="preloaderCount">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            <div className="col-lg-12 col-md-12 mb-4 mb-lg-0">
              <div className="fisherman-content">
                <h6>Videos</h6>
                <h3>Our Video Gallery</h3>
              </div>
            </div>
            {/* col-lg-4 col-lg-4 col-sm-6 col-xs-6 */}
            <div className="videoItems">
              <div className="row">
                {videoData.map((item) => {
                  return (
                    <div
                      className="col-lg-4 col-lg-4 col-sm-6 col-xs-6"
                      key={item.id}
                    >
                      <div className="videoFrame">
                        <video width={"100%"} height={"100%"} muted autoPlay controls>
                          <source src={item.url} type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default VideoGallery;
